import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core-react/ssr/render';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { SECTION_ID_MAPPING } from 'src/app/pages/petitionDetails/shared/constants';

import { useScrollToSection } from '../../hooks/useScrollToSection';
import { SignFormContainer } from '../signFormSunrise';

import { useEmbedSignFormExperiment } from './hooks';

export function EmbeddedSignForm(): JSX.Element | null {
	const {
		data: { isEnabled },
	} = useEmbedSignFormExperiment();

	const {
		data: { refs },
	} = useScrollToSection();

	if (!isEnabled) {
		return null;
	}

	return (
		<div id={SECTION_ID_MAPPING.EMBEDDED_SIGN_FORM} ref={refs[SECTION_ID_MAPPING.EMBEDDED_SIGN_FORM]}>
			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Loader size="s" mt={64} mx="auto" />}>
				<Text className="mt-0 mb-4" variant="heading" as="h2" size="x-small">
					Complete your signature
				</Text>

				<div>
					<SignFormContainer />
				</div>
			</ClientRender>
		</div>
	);
}
